<template>
	<div>
		<v-card-text>
			<p class="mb-4">
				<template v-if="method === 'email'">Abbiamo inviato un codice di 6 cifre alla tua email. Inseriscilo per completare l'accesso.</template>
				<template v-else>Apri l'app di autenticazione (Google Authenticator o simili) e inserisci il codice di 6 cifre.</template>
			</p>
			<v-text-field hide-details="auto"
				ref="code"
				v-model="code"
				:label="useBackup ? 'Codice di backup' : 'Codice di verifica'"
				:placeholder="useBackup ? 'XXXX-XXXX' : '123456'"
				prepend-icon="mdi-shield-key-outline"
				autocomplete="one-time-code"
				:inputmode="useBackup ? 'text' : 'numeric'"
				autofocus
				@keyup.enter="verify"
			></v-text-field>
			<div class="d-flex flex-wrap">
				<v-btn text small color="primary" class="px-0 mr-4" @click="toggleBackup">
					{{ useBackup ? 'Usa il codice di verifica' : 'Usa un codice di backup' }}
				</v-btn>
				<v-btn v-if="method === 'email' && !useBackup" text small color="primary" class="px-0" :loading="resending" @click="resend">
					Invia di nuovo il codice
				</v-btn>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-btn text @click="$emit('cancel')">Indietro</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="primary" :loading="loading" :disabled="!code" @click="verify">Verifica</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
/**
 * Secondo passaggio del login per gli utenti con autenticazione a due fattori.
 * Riceve il token di sfida restituito da /auth/login ed emette `success` a login completato,
 * `error` con il codice del backend (1010-1013) e `cancel` per tornare a email e password.
 */
export default {
	name: 'TwoFactorStep',
	props: {
		challengeToken: { type: String, required: true },
		method: { type: String, default: 'totp' },
	},
	data() {
		return {
			code: '',
			useBackup: false,
			loading: false,
			resending: false,
		};
	},
	methods: {
		toggleBackup() {
			this.useBackup = !this.useBackup;
			this.code = '';
		},
		async verify() {
			if (!this.code || this.loading) {
				return;
			}
			this.loading = true;
			const response = await this.$store.dispatch('profile/loginTwoFactor', { challengeToken: this.challengeToken, code: this.code });
			this.loading = false;

			if (response && response.status === 201) {
				this.$emit('success', { backupCodeUsed: !!response.data.backupCodeUsed });
				return;
			}
			this.code = '';
			const message = response && response.data && response.data.message;
			this.$emit('error', message || 1010);
			// sfida scaduta o troppi tentativi: si torna a email e password
			if (message === 1011 || message === 1012) {
				this.$emit('cancel');
			}
		},
		async resend() {
			this.resending = true;
			const result = await this.$store.dispatch('profile/resendTwoFactorCode', { challengeToken: this.challengeToken });
			this.resending = false;
			if (result.success) {
				this.$emit('info', 'Nuovo codice inviato');
			} else {
				this.$emit('error', result.message || 1007);
			}
		},
	},
};
</script>
